module.exports = __webpack_public_path__ + "media/images/pic/testimonials/monika-e7e3e311985e7b24a20e7699048226c4.webp";